module.exports = __webpack_public_path__ + "static/img/index-banner1.fff508c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index-banner1.png
// module id = BAbI
// module chunks = 1